import Status from "../constants/Status";
import DataExportStatus from "../constants/DataExportStatus";

export function statusIconClassName(status: $TSFixMe) {
  switch (status) {
    case Status.CRITICAL:
      return "icon lcm-iot-icon-circle text-danger";
    case Status.WARNING:
      return "icon lcm-iot-icon-circle text-warning";
    case Status.SUCCESS:
      return "icon lcm-iot-icon-circle text-success";
    default:
      return "icon lcm-iot-icon-circle text-muted";
  }
}

export function statusForProductStatus(status: $TSFixMe) {
  switch (status) {
    case "order_stop":
      return Status.CRITICAL;
    case "phase_out":
      return Status.WARNING;
    case "available":
      return Status.SUCCESS;
    default:
      return Status.UNDEFINED;
  }
}

export function productStatusIconClassName(status: $TSFixMe) {
  return statusIconClassName(statusForProductStatus(status));
}

export function statusForCriticality(criticality: $TSFixMe) {
  switch (criticality) {
    case "high":
      return Status.CRITICAL;
    case "medium":
      return Status.WARNING;
    case "low":
      return Status.SUCCESS;
    default:
      return Status.UNDEFINED;
  }
}

export function criticalityIconClassName(status: $TSFixMe) {
  return statusIconClassName(statusForCriticality(status));
}

export function statusForAccessibility(accessibility: $TSFixMe) {
  switch (accessibility) {
    case "difficult":
      return Status.CRITICAL;
    case "moderate":
      return Status.WARNING;
    case "easy":
      return Status.SUCCESS;
    default:
      return Status.UNDEFINED;
  }
}

export function accessibilityIconClassName(status: $TSFixMe) {
  return statusIconClassName(statusForAccessibility(status));
}

export function statusForInstrumentationStatus(status: $TSFixMe) {
  switch (status) {
    case "inactive":
      return Status.WARNING;
    case "active":
      return Status.SUCCESS;
    default:
      return Status.UNDEFINED;
  }
}

export function instrumentationStatusIconClassName(status: $TSFixMe) {
  return statusIconClassName(statusForInstrumentationStatus(status));
}

export function statusForAssetStatus(status: $TSFixMe) {
  switch (status) {
    case "defective":
      return Status.CRITICAL;
    case "failure":
      return Status.WARNING;
    case "inactive":
      return Status.WARNING;
    case "active":
      return Status.SUCCESS;
    default:
      return Status.UNDEFINED;
  }
}

export function assetSatusIconClassName(status: $TSFixMe) {
  return statusIconClassName(statusForAssetStatus(status));
}

export function exportDataStatusIconClassName(status: $TSFixMe) {
  switch (status) {
    case DataExportStatus.FAILED:
      return "lcm-iot-icon-circle status-error icon";
    case DataExportStatus.IN_PROGRESS:
      return "lcm-iot-icon-circle status-warning icon";
    case DataExportStatus.DONE:
      return "lcm-iot-icon-circle status-success icon";
    default:
      return "lcm-iot-icon-circle status-undefined icon";
  }
}
